import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import PrivacyConfidentiality from './PrivacyConfidentiality';

export default function Blog() {
  return (
    <>
        <Navbar />
        <PrivacyConfidentiality />
        <Footer />
        <Copyright />
    </>
  )
}